module.exports = __webpack_public_path__ + "static/media/landcruiser-9.5f4d7d66.png";